module.exports = ['$$misc',
  function ($$misc) {
    initSchedule()
    // 初始化日程模块
    function initSchedule() {
      // $scope.isLoading = true
      const ln = document.querySelector('#scheduleModal')
      ln.src = $$misc.subModule.scheduleSrc

      // 未知原因，onload 没有生效
      // 希望在子模块中自行实现应用的 onload
      // ln.onload = function () {
      //   $scope.isLoading = false
      // }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/schedule/scheduleCtrl.js